<template>
  <div class="loanDetails">
    <v-card class="box" height="100%">
        <v-card-text>
            <v-layout row wrap fill-height>
                <v-flex xs12 class="headline mb-3">
                    Loan Details
                </v-flex>
                <v-flex xs12>
                    <v-text-field v-model="value.amount" prefix="$" label="Loan Amount" placeholder="Loan Amount" dark v-validate="'required|numeric|min_value:'+this.$minLoan"  
                    data-vv-name="Loan amount" :error-messages="errors.collect('Loan amount') "></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-select
                            :items="loanTermItems"
                            v-show="loanTermItems.length > 0"
                            v-model='value.term'
                            suffix=" months"
                            dark
                            label="Loan Term"></v-select>
                </v-flex>
                <v-flex xs12>
                    Use Of Car<br>
                    <switch-button :value1="buttonValues.PRIVATE" :value2="buttonValues.BUSINESS" @update="value.carUse=$event"></switch-button>
                </v-flex>
                <v-flex xs12>
                    Residency<br>
                        <switch-button :value1="buttonValues.OWNER" :value2="buttonValues.RENTING" @update="value.residency=$event"></switch-button>
                </v-flex>
                <v-flex xs12>
                    Credit Rating<br>
                    <switch-button :value1="buttonValues.GOOD" :value2="buttonValues.AVERAGE" @update="value.creditRating=$event"></switch-button>

                </v-flex>
                <v-flex xs12>
                    Type Of Car<br>
                    <switch-button :value1="buttonValues.NEW" :value2="buttonValues.USED" @update="value.carType=$event"></switch-button>
                </v-flex>
                

            </v-layout>
        </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SwitchButton from "./SwitchButton.vue";

export default {
  name: "LoanDetails",
  props: {
    value: Object
  },
  components: { SwitchButton },
  data() {
    return {
      buttonValues: Object.assign({}, this.$buttonValues),
      loanTermItems: [12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84]
    };
  },
  watch: {
    value: {
      handler: function(val) {
        this.$emit("input", val);
        console.log("EMMITEED");
      },
      deep: true
    }
  }
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  background-color: #212121 !important;
  color: white;
}
.loanDetails {
  height: 100%;
}
</style>
